import { __extends } from "tslib";
import React, { Component } from 'react';
import { ItemGroup } from '@atlaskit/item';
var DropdownItemGroup = /** @class */ (function (_super) {
    __extends(DropdownItemGroup, _super);
    function DropdownItemGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DropdownItemGroup.prototype.render = function () {
        var _a = this.props, children = _a.children, elemAfter = _a.elemAfter, title = _a.title;
        return (React.createElement(ItemGroup, { elemAfter: elemAfter, title: title, role: "menu" }, children));
    };
    return DropdownItemGroup;
}(Component));
export default DropdownItemGroup;
//# sourceMappingURL=DropdownItemGroup.js.map